export class BankFilter {
  CompanyId: number;

  constructor(companyId: number) {
    this.CompanyId = companyId;
  }
}
